import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-global-line text-2xl"></i>
              <span className="text-lg font-bold font-heading">免费资源导航</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              精选全网最优质的免费网站资源，涵盖免费建站平台、免费域名、免费主机、免费CDN等，帮助个人与企业零费用搭建专业网站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 font-heading text-background-100">
              <a href="#quick-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/free-website-builders" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">资源分类</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 font-heading text-background-100">
              <a href="#resource-categories" className="cursor-pointer">资源分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 font-heading text-background-100">联系方式</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              如有任何问题或建议，欢迎通过关于我们页面的联系表单与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 免费资源导航 - 免费网站资源一站式平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}